import { Avatar, AvatarFallback } from '@bnsn/ui/components/avatar'
import { UserIcon } from 'lucide-react'

export const StrategistChatUserAvatar = () => {
  return (
    <Avatar className="h-6 w-6">
      <AvatarFallback className="flex items-center justify-center bg-muted text-foreground">
        <UserIcon className="h-3.5 w-3.5" />
      </AvatarFallback>
    </Avatar>
  )
}
